import React, { createContext, useContext, useState } from "react";

// Criação do contexto
const PublicLayoutContext = createContext(undefined);

export function PublicLayoutProvider({ children }) {
  const [layout, setLayout] = useState(null);

  return (
    <PublicLayoutContext.Provider value={{ layout, setLayout }}>
      {children}
    </PublicLayoutContext.Provider>
  );
}

export function usePublicLayoutContext() {
  const context = useContext(PublicLayoutContext);

  if (context === undefined) {
    throw new Error("❌ usePublicLayoutContext deve ser usado dentro de <PublicLayoutProvider>");
  }

  return context;
}
